<div
  *ngIf="popupService.popups().length"
  class="campaign-popup-host pointer-events-none fixed top-20 z-[1001] w-[min(100%,24rem)] ltr:right-4 rtl:left-4"
  aria-live="polite"
>
  <div class="pointer-events-auto flex flex-col gap-3">
    <article
      *ngFor="let item of popupService.popups(); trackBy: trackById"
      class="cnp-card relative overflow-hidden rounded-xl border border-white-light/80 bg-white shadow-[0_8px_24px_rgba(0,0,0,0.12)] dark:border-white/10 dark:bg-[#0e1726] dark:shadow-[0_8px_28px_rgba(0,0,0,0.4)]"
      [class.cnp-card--success]="item.type === 'success'"
      [class.cnp-card--error]="item.type === 'error'"
      [class.cnp-card--warning]="item.type === 'warning'"
      [class.cnp-card--info]="item.type === 'info'"
      [class.cursor-pointer]="!!item.notificationId"
      (click)="onPopupClick(item)"
    >
      <div class="cnp-accent pointer-events-none absolute inset-y-0 left-0 w-1"></div>

      <div class="relative z-[1] p-4 ps-5">
        <div class="mb-1 flex items-start justify-between gap-2">
          <div class="min-w-0 flex-1">
            <p class="m-0 text-[10px] font-bold uppercase tracking-wide text-primary">Campaign Alert</p>
            <h2 class="m-0 mt-0.5 text-sm font-semibold text-black dark:text-white-light">{{ categoryLabel(item) }}</h2>
          </div>
          <button
            type="button"
            class="cnp-close -me-1 -mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded text-white-dark/60 transition hover:bg-black/5 hover:text-black dark:hover:bg-white/10 dark:hover:text-white-light"
            (click)="dismiss(item.id, $event)"
            aria-label="Dismiss notification"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          </button>
        </div>

        <p *ngIf="item.message" class="m-0 text-xs leading-relaxed text-white-dark dark:text-gray-400">
          {{ item.message }}
        </p>
      </div>
    </article>
  </div>
</div>
